<template>
    <div class="preloader-area">
        <div class="preloader">
            <div class="loader">
                <div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="waviy">
                <span>D</span>
                <span>A</span>
                <span>R</span>
                <span>K</span>
                <span>&nbsp;</span>
                <span>V</span>
                <span>O</span>
                <span>I</span>
                <span>C</span>
                <span>E</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Preloader'
}
</script>